<div class="date-range-extended-container">
	<div class="date-range-extended-range-type">
		<label>
			<input type="radio" [checked]="rangeType === 0"
				   (change)="rangeType = 0; onRangeTypeChanged()" />
			{{'FixedDate' | cpLabelTranslate}}
		</label>

		<label>
			<input type="radio" [checked]="rangeType === 1"
				   (change)="rangeType = 1; onRangeTypeChanged()" />
			{{'RelativeDate' | cpLabelTranslate}}
		</label>

		<label>
			<input type="radio" [checked]="rangeType === 2"
				   (change)="rangeType = 2; onRangeTypeChanged()" />
			{{'TimeWindow' | cpLabelTranslate}}
		</label>
	</div>

	<div *ngIf="rangeType === 0">
		<div>
			<div *ngIf="dateType === 'Date'">
				<cp-date-range-new-picker
						[dateRange]="{from: fromDate, to:toDate}"
						[rangeIsMandatory]="rangeIsMandatory"
						(onChange)="onChange.emit({from: $event.from, to: $event.to, rangeType:rangeType})">
				</cp-date-range-new-picker>
			</div>
			<div *ngIf="dateType === 'DateTime'">
				<cp-datetime-range-picker
						[dateTimeRange]="{from: fromDate, to:toDate}"
						[rangeIsMandatory]="rangeIsMandatory"
						(onChange)="onChange.emit({from: $event.from, to: $event.to, rangeType:rangeType})">
				</cp-datetime-range-picker>
			</div>
		</div>
	</div>

	<div *ngIf="rangeType === 1" class="date-range-extended-relative-date">
		<div class="relative-date">
			<div class="duration-wrapper">
				<label>{{'duration' | cpLabelTranslate}}:</label>
				<div class="duration">
					<kendo-numerictextbox [(value)]="duration"
										  [min]="1"
										  [max]="365"
										  [format]="'0'"
										  [autoCorrect]="true"
										  (valueChange)="computeRelativeDateFactors(); buildRelativeDatesSimulateLabel()">
					</kendo-numerictextbox>
					<kendo-dropdownlist [(ngModel)]="durationScale"
										[data]="scaleTypes"
										[textField]="'description'"
										[valueField]="'name'"
										(ngModelChange)="computeRelativeDateFactors(); buildRelativeDatesSimulateLabel()">
					</kendo-dropdownlist>
				</div>
			</div>
			<div class="start-wrapper">
				<label>{{'starting' | cpLabelTranslate}}:</label>
				<div class="start">
					<kendo-numerictextbox [(value)]="start"
										  [min]="0"
										  [max]="365"
										  [format]="'0'"
										  [autoCorrect]="true"
										  (valueChange)="computeRelativeDateFactors(); buildRelativeDatesSimulateLabel()">
					</kendo-numerictextbox>
					<kendo-dropdownlist [(ngModel)]="startScale"
										[data]="scaleTypes"
										[textField]="'description'"
										[valueField]="'name'"
										(ngModelChange)="computeRelativeDateFactors(); buildRelativeDatesSimulateLabel()">
					</kendo-dropdownlist>
					<label>{{'ago' | cpLabelTranslate}}</label>
				</div>
			</div>
		</div>
		<div class="relative-example-label">
			<label *ngIf="exampleLabel" [innerHTML]="exampleLabel"></label>
			<label *ngIf="exampleLabel === undefined">{{noStartDateSelectedText | cpLabelTranslate}}</label>
		</div>
	</div>

	<div *ngIf="rangeType === 2" class="date-range-extended-relative-date">
		<div class="relative-date">
			<div class="last-wrapper">
				<label>{{'last' | cpLabelTranslate}}:</label>
				<div class="last">
					<kendo-numerictextbox [(value)]="last"
										  [min]="1"
										  [max]="365"
										  [format]="'0'"
										  [autoCorrect]="true"
										  (valueChange)="computeTimeWindowDateFactors(); buildTimeWindowSimulateLabel()">
					</kendo-numerictextbox>
					<kendo-dropdownlist [(ngModel)]="lastScale"
										[data]="scaleTypes"
										[textField]="'description'"
										[valueField]="'name'"
										(ngModelChange)="setIncludingCurrentScale(); computeTimeWindowDateFactors(); buildTimeWindowSimulateLabel()">
					</kendo-dropdownlist>
					<cp-checkbox
							[(ngModel)]="includingCurrent"
							(ngModelChange)="computeTimeWindowDateFactors(); buildTimeWindowSimulateLabel()"
							[label]="'IncludingThis'|cpLabelTranslate">
					</cp-checkbox>
					<label class="including-current-scale">{{includingCurrentScale}}</label>
				</div>
			</div>
		</div>
		<div class="relative-example-label">
			<label *ngIf="exampleLabel" [innerHTML]="exampleLabel"></label>
			<label *ngIf="exampleLabel === undefined">{{noStartDateSelectedText | cpLabelTranslate}}</label>
		</div>
	</div>
</div>
